import { Cloud } from '@silbo/core';
import { useMutation } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { ON_BREAK } from '../const/status';
import { useCurrentPorter } from './useCurrentPorter';

const useBreak = () => {
  const porter = useCurrentPorter();
  const [isOnBreak, setIsOnBreak] = useState(porter?.status === ON_BREAK);

  useEffect(() => {
    setIsOnBreak(porter?.status === ON_BREAK);
  }, [porter?.status]);

  const { mutate: takeBreak, isPending: isTakeBreakPending } = useMutation({
    mutationFn: () => Cloud.takeBreak({ breakType: 'COFFEE_BREAK' }),
    onSuccess: () => setIsOnBreak(true),
  });

  const { mutate: leaveBreak, isPending: isLeaveBreakPending } = useMutation({
    mutationFn: () => Cloud.leaveBreak(),
    onSuccess: () => setIsOnBreak(false),
  });

  return {
    isOnBreak,
    loading: isTakeBreakPending || isLeaveBreakPending,
    takeBreak,
    leaveBreak,
  };
};

export default useBreak;
